import { ref as databaseRef, get, set } from 'firebase/database';

import type { OptOutStatus } from '@/features/analytics';
import { api } from '@/providers/api';
import { getFirebaseDatabase } from '@/providers/firebase';
import { optOutTracking } from '@/utils/opt-out';

const optOutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    optOut: builder.mutation<unknown, undefined>({
      query: () => ({
        url: '/opt-out',
        method: 'POST',
      }),
    }),
  }),
});

export async function getOptOutStatus(uid: string): Promise<OptOutStatus> {
  const optOutStatusRef = databaseRef(
    getFirebaseDatabase(),
    `${uid}/optOutStatus`,
  );
  const optOutStatus = await get(optOutStatusRef);
  if (optOutStatus.exists()) {
    return optOutStatus.val() as OptOutStatus;
  }
  return null;
}

export async function setOptOutStatus(
  uid: string,
  status: OptOutStatus,
): Promise<void> {
  const optOutStatusRef = databaseRef(
    getFirebaseDatabase(),
    `${uid}/optOutStatus`,
  );
  await set(optOutStatusRef, status);
}

let optedOut = false;

export async function optOutProcess(uid: string): Promise<OptOutStatus> {
  const optOutStatus = await getOptOutStatus(uid);
  const isOptedOut = document.cookie.includes('marketing_opted_out=1');
  if (optOutStatus === null && !isOptedOut) {
    return null;
  }

  if (optedOut) {
    return 'confirmed';
  }

  if (optOutStatus === 'pending' || (optOutStatus === null && isOptedOut)) {
    void setOptOutStatus(uid, 'confirmed');
    optedOut = true;
  }

  optOutTracking();
  return 'confirmed';
}

export const { useOptOutMutation } = optOutApi;
